import { createAction, createActionGroup, emptyProps, props } from '@ngrx/store';

import { Document, ViError } from '@vi-iot/client';

export namespace DocumentsActions {
  export enum Type {
    GET_DOCUMENTS = '[DOCUMENTS] Get documents',
    GET_DOCUMENTS_SUCCESS = '[DOCUMENTS] Get documents success',
    GET_DOCUMENTS_ERROR = '[DOCUMENTS] Get documents error',
    GET_UPDATED_DOCUMENTS = '[DOCUMENTS] Get documents updated',
    GET_UPDATED_DOCUMENTS_SUCCESS = '[DOCUMENTS] Get documents updated success',
    GET_UPDATED_DOCUMENTS_ERROR = '[DOCUMENTS] Get documents updated error',
    AGREE_ON_DOCUMENTS = '[DOCUMENTS] Agree on documents',
    POST_AGREEMENT = '[DOCUMENTS] Post documents agreement',
    POST_AGREEMENT_SUCCESS = '[DOCUMENTS] Post documents agreement success',
    DATA_USAGE_AGREEMENT_DOCUMENT = '[DOCUMENTS] Get data usage agreement document',
  }

  export const getDocuments = createAction(Type.GET_DOCUMENTS);

  export const getDocumentsSuccess = createAction(
    Type.GET_DOCUMENTS_SUCCESS,
    props<{ documents: Document[] }>()
  );

  export const getDocumentsError = createAction(Type.GET_DOCUMENTS_ERROR);

  export const getUpdatedDocuments = createAction(
    Type.GET_UPDATED_DOCUMENTS,
    props<{ userCountryCode: string }>()
  );

  export const getUpdatedDocumentsSuccess = createAction(
    Type.GET_UPDATED_DOCUMENTS_SUCCESS,
    props<{ updatedDocuments: Document[] }>()
  );

  export const getUpdatedDocumentsError = createAction(Type.GET_UPDATED_DOCUMENTS_ERROR);

  export const agreeOnDocuments = createAction(Type.AGREE_ON_DOCUMENTS);

  export const dataUsageAgreementDocument = createActionGroup({
    source: Type.DATA_USAGE_AGREEMENT_DOCUMENT,
    events: {
      attempt: emptyProps(),
      success: props<{ documents: Document[] }>(),
      error: props<{ error: ViError }>(),
    },
  });

  export const postAgreement = createAction(Type.POST_AGREEMENT, props<{ revisionId: string }>());

  export const postAgreementSuccess = createAction(Type.POST_AGREEMENT_SUCCESS);
}
